import fr from '../i18n/fr.json';

type Dict = Record<string, string>;

const dict: Dict = fr;

export function t(key: string): string {
  return dict[key] ?? key;
}
